import { Navigate } from "react-router-dom"
import { useAuthUserDetails } from "@apis/users/useUsers"

interface RoleGuardProps {
  allowedRoles: string[]
  children: React.ReactElement
}

export const RoleGuard = ({ allowedRoles, children }: RoleGuardProps) => {
  const { data: userData } = useAuthUserDetails()

  const hasAccess =
    userData &&
    userData.roles &&
    userData.roles.some((role) => allowedRoles.includes(role.name))

  if (!hasAccess) {
    // Logged in but not authorized
    return <Navigate to="/" replace />
  }

  return children
}
